import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../contexts/AuthContext";
import { API } from "../config/api";


export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const params = new URLSearchParams(hash.replace("#", "?"));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await axios.post(
          `${API}/auth/callback`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        await checkAuth();
        navigate("/admin/dashboard", {
          replace: true,
          state: { user: res.data.user }
        });
      } catch (err) {
        console.error("Auth callback error:", err);
        navigate("/admin/login", { replace: true });
      }
    };

    exchangeSession();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-3 border-emerald-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-slate-600 font-medium">Přihlašování...</p>
        <p className="text-slate-400 text-sm">Ověřuji Váš účet</p>
      </div>
    </div>
  );
}
